import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';

import { TransparentModal } from '@sg/garnish';

import { useNavigateBack } from '../../navigation';
import { DeliveryOrderInFlightContent } from './DeliveryOrderInFlightContent';

export const DeliveryOrderInFlightScreen = () => {
  const router = useRouter();
  const { formatMessage } = useIntl();
  const { orderId } = useLocalSearchParams<{ orderId?: string }>();
  const navigateBack = useNavigateBack();

  const handleClose = useCallback(() => {
    navigateBack();
  }, [navigateBack]);

  const handleOrderStatus = useCallback(() => {
    router.replace({
      pathname: '/order-status/[orderId]',
      params: { orderId: orderId ?? '' },
    });
  }, [router, orderId]);

  return (
    <TransparentModal
      testID="delivery-order-in-flight"
      accessibilityLabel={formatMessage(messages.dialogA11yLabel)}
      size="medium"
      onClose={handleClose}
    >
      <DeliveryOrderInFlightContent onClose={handleClose} onOrderStatus={handleOrderStatus} />
    </TransparentModal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  dialogA11yLabel: {
    defaultMessage: 'You already have an order on the way',
    description: 'Delivery | In Flight Modal | Dialog a11y label',
  },
});
